<template>
  <div class="page-header">
    <div class="level">
      <div class="level-left">
        <a @click="$router.push('/')"
          ><img alt="Multivision" src="../assets/logo.png" class="logotype"
        /></a>
      </div>
      <div class="level-right">
        <a
          @click="$router.push('performance')"
          class="header-item"
          v-if="canSeePerformance"
          >Performance</a
        >
        <a @click="$router.push('account')" class="header-item">Account</a>
        <a @click="logout" class="header-item">Logout</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  computed: {
    canSeePerformance() {
      return (
        localStorage.getItem('profile') == 'Manager' ||
        localStorage.getItem('profile') == 'Admin'
      );
    }
  }
};
</script>

<style lang="scss">
.page-header {
  background: #333333;
  height: 60px;
  flex-grow: 0;
  flex-shrink: 0;
  padding: 0 18px;
  color: #aaaaaa;

  .level {
    height: 60px;
  }

  a {
    color: #aaaaaa;
  }

  .header-item {
    margin-left: 40px;
  }
}
</style>
